<template>
  <div class="mall-bottom-sheet">
    <div class="mall-bottom-sheet__dim" :class="'mall-bottom-sheet__dim--' + dim" @click="$emit('close')"></div>
    <div class="mall-bottom-sheet__panel" :class="{ 'mall-bottom-sheet__panel--handle': handle }">
      <div v-if="handle" class="mall-bottom-sheet__handle-area">
        <div class="mall-bottom-sheet__handle"></div>
      </div>
      <div class="mall-bottom-sheet__content">
        <slot />
      </div>
      <div class="mall-bottom-sheet__buttons">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallBottomSheet',
  props: {
    // 상단 손잡이(handle) 노출 여부
    handle: {
      type: Boolean,
      default: false,
    },
    // 바깥 어두운 영역: 'light'(56%) | 'normal'(80%, Figma dimmed-black-normal)
    dim: {
      type: String,
      default: 'light',
    },
  },
}
</script>

<style scoped>
.mall-bottom-sheet__dim {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(24, 24, 28, 0.56);
  z-index: 1000;
}

.mall-bottom-sheet__dim--normal {
  background: rgba(24, 24, 28, 0.8);
}

.mall-bottom-sheet__panel {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  width: 100%;
  max-width: 600px;
  max-height: calc(100vh - 24px);
  padding: 20px 16px 16px 16px;
  flex-direction: column;
  gap: 20px;
  border-radius: 20px 20px 0 0;
  background: #FFF;
  box-sizing: border-box;
  z-index: 1001;
}

.mall-bottom-sheet__panel--handle {
  padding-top: 0;
}

.mall-bottom-sheet__handle-area {
  display: flex;
  flex-shrink: 0;
  padding: 12px 0;
  justify-content: center;
}

.mall-bottom-sheet__handle {
  width: 52px;
  height: 4px;
  border-radius: 10000px;
  background: #D1D6DB;
}

.mall-bottom-sheet__content {
  min-height: 0;
  overflow-y: auto;
}

.mall-bottom-sheet__buttons {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallBottomSheet.vue